import {
  api_portalOfficeListing_filter,
  ibow2_proto_PortalOfficeListingService,
} from '@/init/swagger';
import { assortServiceItems } from '@/helpers/serviceCategory';

type Props = {
  services: ibow2_proto_PortalOfficeListingService[];
  searchFilters: api_portalOfficeListing_filter[];
};

export const useLogic = ({ services, searchFilters }: Props) => {
  const { services: serviceCategoryItems } = assortServiceItems({
    items: services,
    masterItems: searchFilters,
  });

  const hasServiceCategoryItems =
    serviceCategoryItems && serviceCategoryItems.length > 0;

  return {
    serviceCategoryItems,
    hasServiceCategoryItems,
  };
};
